<template>
    <div v-if="allotments?.length">
        <pageHeader page-title="Criar Reserva" has-slot>
            <template #container>
                <div class="toolbar-select mr-2">
                            <span class="toolbar-select-label">
                                <i class="icon-grid"></i>
                                {{ t('NAV.ALLOTMENT_S') }}:
                            </span>
                    <div class="toolbar-select-control">
                        <select2 :settings="{ width: '100%', placeholder:  'Loteamentos'}"
                                 :options="allotments"
                                 v-model="allotmentId" @select="changeAllotment($event)"/>
                    </div>
                </div>
            </template>
        </pageHeader>
        <load-screen-component/>
        <WizardComponent :steps="[
                            {id:'clients',description:'Informe ou cadastre um cliente', label: 'Clientes', icon:'icon-people', slot:'client'},
                            {id:'lotes',description:'Selecione um lote', label: 'Lotes', icon:'icon-map2', slot:'lotes'},
                            {id:'reserve',description:'valide a reserva', label: 'Reserva', icon:'icon-lock-open', slot:'reserve'},
                            {id:'proposta',optional:true,description:'Gere uma proposta', label: 'Propostas', icon:'icon-file-text', slot:'proposal'},
                            ]"
                         navigation-position="left">
            <template #client>
                <ReserveStepClients/>
            </template>
            <template #lotes>
                <ReserveStepLots/>
            </template>
            <template #reserve>
                <ReserveStepReview/>
            </template>
            <template #proposal>
            </template>
        </WizardComponent>
        <modalSelectAllotmentComponent
                :showModal="showModalAllotment"
                scope-allotment @showModal="showModalAllotment = $event"
                @allotmentSelected="allotmentModalSelect"></modalSelectAllotmentComponent>
    </div>
    <div v-else></div>
</template>

<script>
import LoadScreenComponent from '@/components/layouts/loadScreenComponent';
import WizardComponent from '../../components/layouts/WizardComponent';
import pageHeader from '../../components/layouts/pageHeader';
import ReserveStepClients from './steps/ReserveStepClients.vue';
import ReserveStepLots from './steps/ReserveStepLots.vue';
import ReserveStepReview from './steps/ReserveStepReview.vue';
import {mapActions, mapState} from 'vuex';
import UserCompanies from '../../services/UserCompanies';
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Select2 from 'vue3-select2-component';
import modalSelectAllotmentComponent from '../allotment/modalSelectAllotmentComponent';

export default {
    name: 'createReserveByStep',
    components: {
        LoadScreenComponent,
        modalSelectAllotmentComponent,
        WizardComponent,
        Select2,
        pageHeader,
        ReserveStepClients,
        ReserveStepLots,
        ReserveStepReview,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    data() {
        return {
            allotmentId: null,
            showModalAllotment: false,
        }
    },
    watch:{
        allotments(){
            if (!this.allotmentId){
                if (this.allotments.length === 1){
                    this.changeAllotment({id:this.allotments.find((i) => i).id});
                }else {
                    this.showModalAllotment = true;
                }
            }
        }
    },
    computed: {
        ...mapState({
            allotments: 'allotments',
        }),
    },
    mounted() {
        if (!this.$isAnonymous()){
            this.$router.push({name:'Home'});
            return;
        }
        if (sessionStorage.getItem('allotmentIdScope')){
            this.changeAllotment({id: sessionStorage.getItem('allotmentIdScope')});
        }else if (this.allotments?.length) {
            if (this.allotments.length === 1){
                this.changeAllotment({id:this.allotments.find((i) => i).id});
            }else{
                this.showModalAllotment = true;
            }
        }
    },
    methods: {
        ...mapActions({
            blocksListAvailableAction: 'blocksListAvailableAction',
            blocksListAvailableResumAction: 'blocksListAvailableResumAction',
            getPermissionsAllotmentAction: 'getPermissionsAllotmentAction',
        }),
        async changeAllotment({id}) {
            this.$store.commit('changeLoading', true);
            sessionStorage.setItem('allotmentIdScope', id);
            this.allotmentId = id;
            await this.chanceCustomScope(this.allotmentId);
            this.blocksListAvailableAction({allotmentId: sessionStorage.getItem('allotmentIdScope')});
            this.blocksListAvailableResumAction({allotmentId: sessionStorage.getItem('allotmentIdScope')});
            this.getPermissionsAllotmentAction({allotmentId: sessionStorage.getItem('allotmentIdScope')});
        },
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(async resp => {
                await this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        async allotmentModalSelect() {
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            await this.chanceCustomScope(this.allotmentId);
        },
    }
};
</script>

